import { IClientParams } from 'node-mailjet/declarations/client/IClient'

export interface MailjetModuleOptions extends IClientParams {}
